(function($, konto, filter) {

	var FilterPanel = function (kontoBaseEl, options) { //constructor
		
		//stack funkcija (ready i loaded)
        this._readyFuncArray = [];
        this._readyExecuted = false;
        this._loadedFuncArray = [];
        this._loadedExecuted = false;
        		
		this.filter = {};		
		this.filterValuesLoaded = false;	
			
		this.filterCacheKey = kontoBaseEl.getCacheKey('panel');		
		this.filterDefaults = options.defaultFilterValues;

		// filter panel je isti za više različitih controllerName (knjiga, salda dijele trebaju imati iste parametre u filteru)  
		this.filterCacheKeyPreslikaj = options.filterCacheKeyPreslikaj;

		//pamćenje buttona i defaulta vrijednost
		this.filterButtonCacheKey = kontoBaseEl.getCacheKey('panel') + '2';
		this.filterButtonDown = false;	
		this.buttonDownDefault = options.defaultButtonDown;
		if (this.buttonDownDefault == undefined) this.buttonDownDefault = false;

		//postavi elemente filtera u filterpanel
		init.call(this, kontoBaseEl);		

		//ucitavanje public funkcija
		initFunctions.call(this, kontoBaseEl);
			
	};
	
	
	konto.FilterPanel = FilterPanel;
	FilterPanel.prototype.constructor = FilterPanel;
	
	function focusNextOnPanelContainer(that, element){
	    focusable = that.panelContainer.find('input,a,select,button,textarea,span.konto-dropdownlist')
	        .filter(':visible')
	        .filter(':not(:disabled)')
	        .filter(':not([readonly])')
	        .filter(':not(.select-readonly)')
	        .filter(':not(.skipEnterTab)');
	    next = focusable.eq(focusable.index(element)+1);
	    if (next.length === 0) {
	        if (focusable.length === 0)
	            return false;
	        next = focusable.eq(0);
	    }
	    next.focus().select();         
	    return false;	
	};

	/**
	 * Početna inicijalizacija filtera 
	 *  - postavljaju se elementi u filter panel
	 *  - definiraju se jquery objekti nekih elemenata
	 */
	function init (kontoBaseEl) {
		var that = this;

		//ucitavanje spremljenih vrijednosti
		ucitajSpremljeneVrijednosti.call(that, kontoBaseEl);
				
		kontoBaseEl.loaded(function () {
						
			//u grid-ov toolbar appendamo elemente filtera
			var tplEl = $("#filterPanel-" + kontoBaseEl.unique);
			var toolbarEl = $("#sif-" + kontoBaseEl.unique + " .main-grid .konto-toolbar.k-grid-toolbar");
					
			toolbarEl.append(tplEl.html());
			tplEl.remove();
			
			//jquery objekti
			that.panelContainer = $("#filterPanelContainer-"+kontoBaseEl.unique);		
			that.filterPanelBtn = $("#filterPanelBtn-"+kontoBaseEl.unique);
			that.filterPanelBtnAkcije = $("#AkcijefilterPanelBtn-"+kontoBaseEl.unique);
			that.ukloniFiltereBtn = $("#ukloniFiltereBtn-"+kontoBaseEl.unique);
			
            //inicijalizacija konto komponenti
			kontoBaseEl.init();

			//eventi
			ucitajEvente.call(that, kontoBaseEl);	

			//pozivanje 'loaded' stacka funkcija			
			that.loaded();	
			
			//da se na enter selektira iduće polje, automatski se izvrši i blur
			that.panelContainer.find(".konto-input").keydown(function(e) { 
            	var key = e.which || e.charCode || e.keyCode;             	
                if (key==13){  //enter
					focusNextOnPanelContainer(that, this);
					return false;
	            }
	         });
         
             //da se na enter selektira iduće polje, automatski se izvrši i blur
             that.panelContainer.find(".sifarnik-group").find("input").keydown(function(e){  
                var code = (e.keyCode ? e.keyCode : e.which);
                if (code==13){  //enter                   	         
					focusNextOnPanelContainer(that, this);
					return false;
                }
            }); 	
						
			//pozivanje 'ready' stacka funkcij
			that.ready();
								
		});	
							
	};
	
	function initFunctions (kontoBaseEl) {
		var that = this;	
		
		//dohvacanje filterData jsona (za ds)
		that.getFilterData = function() {
			var data = {};

			$.each(that.filter, function(field, value) {
				data[field] = value.filterValue;
			});
			
			return JSON.stringify(data);	
		};
		
		//filter dispečer
		that.filterDispatcher = function (e) {
		    var element;
		    var field;

            // input elementi edit, sifarnik ...
		    if (e[0].name !== undefined) {
		        element = e;
		        field = e[0].name;
		    } // kendo elementi            
		    else if (e[0].element[0].name !== undefined){
		        element = e[0].element;
		        field = e[0].element[0].name;
		        
		        if($(element[0]).hasClass("konto-input-date")){
		        	if(element[0].value == '__.__.____'){
		        		element[0].value = '';	
		        	}
		        }
		        if($(element[0]).hasClass("konto-input-year")){
		        	if(element[0].value == '____'){
		        		element[0].value = '';	
		        	}
		        }		        
		    }

		    refreshGrid.call(that, kontoBaseEl, field, element);
		};

	};
	

	function ucitajEvente (kontoBaseEl) {
		var that = this;

		//otvaranje panela
		that.filterPanelBtn.unbind('click').bind('click', function() {
			if (that.panelContainer.is(':visible')) {
				that.panelContainer.fadeOut('fast');
				that.filterButtonDown = false; 
			} else { 
				that.panelContainer.fadeIn('fast');
				that.filterButtonDown = true;
			}	

		    simpleStorage.set(that.filterButtonCacheKey, that.filterButtonDown);	
		});	
		
		that.filterPanelBtnAkcije.unbind('click').bind('click', function() {
			if (that.panelContainer.is(':visible')) {
				that.panelContainer.fadeOut('fast');
				that.filterButtonDown = false; 
			} else { 
				that.panelContainer.fadeIn('fast');
				that.filterButtonDown = true;
			}	

		    simpleStorage.set(that.filterButtonCacheKey, that.filterButtonDown);	
		});			

		//brisanje filtera
		that.ukloniFiltereBtn.bind('click', function() {	
								
        	//ucitavamo pocetne (defaultne) vrijednosti
			ucitajDefaultneVrijednosti.call(that, kontoBaseEl);
			
			//refreshamo grid
			kontoBaseEl.kontoGrid.refresh(false);			
		});
		
	};
    
    /**
     * Ucitavanje spremljenih filter vrijednosti
     */  
	function ucitajSpremljeneVrijednosti (kontoBaseEl) { 
    	var that = this;  
    	  	
    	var spremljeno = simpleStorage.get(that.filterCacheKey);
    	var buttDown = simpleStorage.get(this.filterButtonCacheKey);

    	var btnNotGreen = true;
		
		if (empty(spremljeno))
			that.filter = $.extend({}, that.filterDefaults);
		else
			that.filter = $.extend({}, spremljeno);
		
		if (buttDown == undefined)
			this.filterButtonDown = this.buttonDownDefault;
		else
			this.filterButtonDown = buttDown;	
		
		//postavi spremljene filtere (kada je filter 'ready')	
		that.ready(function () {
			that.panelContainer.find('input:not(.k-input-inner.konto-combobox)').each(function(key, field) {

				var kljuc = key;
				var velju = field;
				
				var polje = $(field);
				var nazivPolja = polje.attr('name');
				var filterVrijednost = polje.sifVal();

				if (isset(that.filter[nazivPolja]) && that.filter[nazivPolja].kendoValue) {

				    kontoBaseEl.setElementValue(polje, that.filter[nazivPolja].kendoValue);

				    if (polje.parent().hasClass('sifarnik-group'))
				    {
				        polje.blur();
				    }

					//ako je element 'button'
					if (polje.hasClass('hasBtn')) {
						if (that.filter[nazivPolja].kendoValue == 1)
							polje.parent().find('button').addClass('active');
						else
							polje.parent().find('button').removeClass('active');
					}
															
					if (btnNotGreen)
						if (!isset(that.filterDefaults[nazivPolja]) || that.filter[nazivPolja].filterValue != that.filterDefaults[nazivPolja].filterValue) {
							that.filterPanelBtn.addClass('active'); //gumb postavljamo zelenim
						}
						
				} else {
					kontoBaseEl.clearElementValue(polje); 
				}
			});
		
			that.filterValuesLoaded = true;
			
			if (btnNotGreen && that.filterButtonDown)
				that.filterPanelBtn.trigger('click');	
			
		});	

   	};

   
   	function ucitajDefaultneVrijednosti (kontoBaseEl) {	
   		var that = this;

   		that.filter = $.extend({}, that.filterDefaults);
   		
   		that.panelContainer.find('input:not(.k-input-inner.konto-combobox)').each(function(key, field) {
			var nazivPolja = $(field).attr('name');
			
			if (typeof that.filter[nazivPolja] !== 'undefined') {				
				kontoBaseEl.setElementValue($(field), that.filter[nazivPolja].kendoValue);
			} else {
				kontoBaseEl.setElementValue($(field), '');
			}
		});
	
		checkChanges.call(that, kontoBaseEl);
	};

	
   /**
    * Refreshanje grid-a 
    */
   function refreshGrid(kontoBaseEl, field, el, objectValue) {
   		var that = this;
   		
		// provjera promjena
		checkChanges.call(that, kontoBaseEl);

    	// defaultno stanje - prosljedjujemo samo element	
    	if (empty(objectValue)) {
        	var kendoValue = kontoBaseEl.getElementValue($(el));
        	var filterValue = el.sifVal();
        	
        //ako proslijedjujemo objekt s vrijednostima
		} else {
			var kendoValue = objectValue.kendoValue;
        	var filterValue = objectValue.filterValue;
		}
	
    	if (field == 'pocetak' || field == 'kraj' || (isset(kendoValue) && isset(filterValue))) {
    		
    		//ako ne postoji, kreiramo objekt
    		if (!isset(that.filter[field]))
    			that.filter[field] = {};
    		
        	that.filter[field].kendoValue = kendoValue;           
        	that.filter[field].filterValue = filterValue;


        }
    	
    	kontoBaseEl.kontoGrid.refresh(false);
   };
   
   /**
    * Refreshanje grid-a 
    */
   function checkChanges(kontoBaseEl) {
   		var that = this;
   	
		var filterActive = false;
		
		that.panelContainer.find('input:not(.k-input-inner.konto-combobox)').each(function(key, field) {
		    var filterVrijednost;
			var isDateField = false;
		    // checkbox setiranje vrijednosti true/false
		    if ($(field).is(':checkbox')) {
		        filterVrijednost = $(field).prop("checked") ? true : 'off';
		    } else {
		        filterVrijednost = $(field).sifVal();
		    }

			var kendoVrijednost = kontoBaseEl.getElementValue($(field));

			var nazivPolja = $(field).attr('name');
			if ($(field).hasClass("konto-input-datetime") || $(field).hasClass("konto-input-date"))
            	isDateField = true;
			
			if ((filterVrijednost != '' && filterVrijednost != null) || isDateField) {
				if (typeof that.filterDefaults[nazivPolja] === 'undefined' || that.filterDefaults[nazivPolja].filterValue != filterVrijednost) 
				{
					filterActive = true; //razlikuje se od defaultnih vrijednosti
				}
				
				//naštimavanje timezone
				if (isDateField && kendoVrijednost){					
					kendoVrijednost.setHours(kendoVrijednost.getHours() - kendoVrijednost.getTimezoneOffset() / 60);	
				}
				
				that.filter[nazivPolja] = {};
				that.filter[nazivPolja].kendoValue = kendoVrijednost; 
				that.filter[nazivPolja].filterValue = filterVrijednost;	
			} else {
				if (typeof that.filter[nazivPolja] !== 'undefined')
					if (typeof that.filterDefaults[nazivPolja] !== 'undefined') {
						that.filter[nazivPolja].filterValue = that.filterDefaults[nazivPolja].filterValue;
						that.filter[nazivPolja].kendoValue = that.filterDefaults[nazivPolja].kendoValue;
					} else {

                        //pg ovo privremeno isključujem je radi probleme, briše spremljene filtere ako ih je više setirano
					    //delete that.filter[nazivPolja];
					}
			}
			
		});

		//spremamo filtere u local store		                	
        if (that.filter !== null) { 
            simpleStorage.set(that.filterCacheKey, that.filter);
        }      

		//ažuriranje filtera filterCacheKeyPreslikaj	
        if (that.filterCacheKeyPreslikaj !== null) { 
            simpleStorage.set(that.filterCacheKeyPreslikaj, that.filter);
        }    
        		
		if (filterActive)
			that.filterPanelBtn.addClass('active');
		else {
			that.filterPanelBtn.removeClass('active');
			simpleStorage.deleteKey(that.filterCacheKey);
		}
   };
       
    
    /**
     * Public
     */
    $.extend(FilterPanel.prototype, {
    	
        /**
         * Ready funkcija u kojoj templateovi mogu registrirati svoje funkcije.
         */ 
        ready: function (func) {
            if (typeof func === "undefined") {   
                $.each(this._readyFuncArray, function (index, item) {
                    item();
                });
                this._readyExecuted = true;
            }
            else if (typeof func === "function") {
                if (this._readyExecuted) 
                    func();
               	else
                    this._readyFuncArray.push(func);
               	               	
            } else { /* krivi parametar*/ }            
        },
        
        /**
         * Loaded funkcija u kojoj templateovi mogu obaviti neku inicijalizaciju.
         */ 
        loaded: function (func) {
            if (typeof func === "undefined") {
                $.each(this._loadedFuncArray, function (index, item) {
                    item();
                });
                this._loadedExecuted = true;
            }
            else if (typeof func === "function") {
                if (this._loadedExecuted)
                    func();
                else
                    this._loadedFuncArray.push(func);
                    
            } else { /* krivi parametar*/ } 
        },
               
        
    });


	
} (jQuery, window.konto = window.konto || {}, konto.FilterPanel = konto.FilterPanel || {}));
